import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/integration/icn_integration_01.png';
import icn_02 from '../../assets/img/landingPage/integration/icn_integration_02.png';
import icn_03 from '../../assets/img/landingPage/integration/icn_integration_03.png';
import icn_04 from '../../assets/img/landingPage/integration/icn_integration_04.png';
import icn_05 from '../../assets/img/landingPage/integration/icn_integration_05.png';
import icn_06 from '../../assets/img/landingPage/integration/icn_integration_06.png';

import keyfeature01 from '../../assets/img/landingPage/integration/integration-01.png';
import keyfeature02 from '../../assets/img/landingPage/integration/integration-02.png';
import keyfeature03 from '../../assets/img/landingPage/integration/integration-03.png';
import keyfeature04 from '../../assets/img/landingPage/integration/integration-04.png';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/integration/Integration_home.png';


const Integration = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Built for change',
            text: "Adopt new technologies and integration patterns rapidly using a modular, AI-augmented architecture that evolves with your business needs.",
            altDescription: "Adopt new technologies and integration patterns rapidly using a modular.",
            image: keyfeature01,
        },
        Key_Feature_02: {
            title: "Boost productivity with Gen-AI",
            text: "Accelerate integration development with Gen-AI copilots. Generate workflows, optimize data mappings, and receive intelligent suggestions.",
            altDescription: "Accelerate integration development with Gen-AI copilots. Generate workflows, optimize data mappings, and receive intelligent suggestions.",
            image: keyfeature02,
        },
        Key_Feature_03: {
            title: 'Virtual-first orchestration',
            text: 
            "Manage integration flows as Virtual APIs, test them in isolated environments, and deploy without affecting production. Speed up delivery with full version control and rollback capabilities.",
            altDescription: 'Manage integration flows as Virtual APIs, test them in isolated environments, and deploy without affecting production. Speed up delivery with full version control and rollback capabilities.',
            image: keyfeature03,
        },
        Key_Feature_04: {
            title: 'Secure and reliable by default',
            text: 
            "Enjoy 99.99% uptime, secure-by-design foundations, and fine-grained control over data flows, access rules, and identity policies — across all environments.",
            altDescription: 'Enjoy 99.99% uptime, secure-by-design foundations, and fine-grained control over data flows, access rules, and identity policies — across all environments.',
            image: keyfeature04,
        },
    }
    
    //Key Benefits Bento
    const items = [
        {
          icon: icn_01,
          title: 'Unify your Data',
          paragraphs: [
            'Create a single source of truth by linking all your systems, regardless of format or source.',
          ],
        
        },
        {
          icon: icn_02,
          title: 'Accelerate Delivery',
          paragraphs: [
            'Start faster with AI-assisted configuration, smart templates, and reusable integration assets.',
          ]
        },

        {
          icon: icn_03,
          title: 'Make Integration Intelligent',
          paragraphs: [
            'Predict bottlenecks, monitor flows, and auto-tune performance with AVAP’s Gen-AI engine.',
          ]
        },
        {
          icon: icn_04,
          title: 'Protect Every Connection',
          paragraphs: [
            'Enforce policies across all connections with dynamic authentication, rate limiting, and encryption — built in.'
          ]
        },
        {
            icon: icn_06,
            title: 'Empower cross-functional collaboration',
            paragraphs: [
              'Enable IT and business teams to co-build, test, and scale integrations together.',
            ]
          },
        {
          icon: icn_05,
          title: 'Measure and Improve',
          paragraphs: [
            'Track integration KPIs in real time with built-in analytics and smart dashboards.',
          ]
        },
      
      ];
      
    const breakpointColumnsObj = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-4">
                    
                    <h1 className="fl-title-big m-0">Integration</h1>
                    <p className="fl-title m-0 gradient-text">Integrate, automate, and scale with <br />
                    AI-driven virtualization</p>
                                <p className="fl-text fl-txt-container-s" >
                                AVAP Integration empowers your teams to securely connect data, automate workflows, and modernize systems — faster and with less effort. 
                                </p>
                                <p className="fl-text fl-txt-container-s" >
                                Built on virtual-first architecture and powered by Gen-AI, it's the integration solution built for today’s agile enterprises.
                                </p>
              </section>

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    <img
                        src={dashboard}
                        className="img-fluid mt-5 pb-8"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />
                    
                    <h2 className="fl-title m-0 gradient-text fl-title m-4">Connect everything. Empower everyone.</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Integration unifies the power of automation, data flow, and intelligent orchestration. With native virtualization and AI assistance, AVAP Framework helps developers and business teams integrate applications, services, and data sources — across clouds, on-premises systems, and legacy architectures — without friction.
                    </p>
                    <p className="fl-text text-center fl-txt-container-s">
                   Free your teams from bottlenecks and legacy dependencies with a platform that adapts to change, scales effortlessly, and delivers real-time integration insights.
                    </p>

                </section>

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">Key Attributes</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>

                {/* Sección Built */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4 text-center">

                                <div className="blob"></div>
    

                                <div className="">
                                    <h3 className='fl-title'>Built for modern teams</h3>
                                    <p>AVAP Integration empowers both IT and business users with no-code/low-code tools and reusable virtual connectors for:
                                    </p>
                                    {/* Sección Bullets */}
                                    <ul className="fl-bullets-built text-center fl-txt-container-s " >
                                    <li className="fl-bullets-built">Cloud & SaaS platforms</li>
                                    <li className="fl-bullets-built">On-prem legacy systems</li>
                                    <li className="fl-bullets-built">Databases & messaging systems</li>
                                    <li className="fl-bullets-built">Internal and third-party APIs</li>                
                                    </ul>
                                    <p className='pt-4'>Break data silos and give teams the freedom to build connected workflows across any system.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container">
                <div className="fl-title text-center mb-5">
                    Key Benefits
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayGradient">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                {/* Sección Key Benefits */}   
               {/* <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                Unify your data
                                </p>
                                <p className="fl-text">
                                Create a single source of truth by linking all your systems, regardless of format or source.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Accelerate delivery
                                </p>
                                <p className="fl-text">
                                Start faster with AI-assisted configuration, smart templates, and reusable integration assets.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Make integration intelligent
                                </p>
                                <p className="fl-text">
                                Predict bottlenecks, monitor flows, and auto-tune performance with AVAP’s Gen-AI engine.

                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Protect every connection
                                </p>
                                <p className="fl-text">
                                Enforce policies across all connections with dynamic authentication, rate limiting, and encryption — built in.

                                </p>
                            </div>
                        </div>
                        
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Measure and improve
                                </p>
                                <p className="fl-text">
                                Track integration KPIs in real time with built-in analytics and smart dashboards.

                                </p>
                            </div>
                        </div>

                    </div>
                </section>*/} 

                {/* Sección built for secure */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="text-center blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="">
                                    <h3 className='fl-title '>Designed for your architecture</h3>
                                    <p>Whether you're operating in the cloud, on-prem, or in hybrid environments, AVAP Framework adapts seamlessly to your infrastructure and governance model.

                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Integration;
